import { Box, Card, CardContent, Skeleton } from "@mui/material"
import "./style.css";

const ItemCardSkeleton = ({ orderType }) => {
  return (
    <Box className='menu-item-card-listing'>
        <Card
        className='menu-item-card-container'
        sx={{
            height: { xs: 140, sm: 160, md: orderType ? 250 : 220 },
        }}
        >
        <Skeleton variant="rectangular" sx={{ flexShrink: 0, height: { xs: 100, sm: 120, md: 140 } }} animation="wave" />
        <CardContent className="card-content-menu-item"
            sx={{ p: { xs: 1, sm: 2, md: 2 } }}
        >
            <Skeleton variant="text" width="80%" height={24} animation="wave" />
            <Box className='card-content-skeleton'>
            <Skeleton variant="text" width={50} height={24} animation="wave" />
            {orderType && (
                <Skeleton variant="rectangular" width={66} height={24} animation="wave" sx={{ borderRadius: "5px" }} />
            )}
            </Box>
        </CardContent>
        </Card>
    </Box>
  )
}

export default ItemCardSkeleton